// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicDescription_wrapper__2ddQx","box":"DynamicDescription_box__3uNyO","p":"DynamicDescription_p__qeQ8F"};